import { useEffect } from 'react';
import HeaderImage from '../../assets/header.jpg'
import Resume from '../../assets/cv.pdf'
import data from './data';
import './header.css'
import AOS from 'aos';
import 'aos/dist/aos.css';


const Header = () => {
  useEffect(() => {
    AOS.init({duration: 2000});
  }, []);

  return (
    <header id="header">
      <div className="container header__container">
        <div className="header__profile" data-aos="flip-up">
          <img src={HeaderImage} alt="Header Portrait" />
        </div>
        <p className="header__eyebrow" data-aos="fade-up">Computer Science & Applied Mathematics</p>
        <h1 data-aos="fade-up">Kai Nguyen</h1>
        <h3 data-aos="fade-up">Software Engineer & AI/ML Enthusiast</h3>
        <p data-aos="fade-up">
          I build practical software and machine learning projects with a focus on thoughtful user experiences, measurable results, and continuous learning.
        </p>
        <div className="header__cta" data-aos="fade-up">
          <a href="#portfolio" className='btn primary'>View My Work</a>
          <a href={Resume} download="Kai-Nguyen-Resume.pdf" className='btn light'>Download Resume</a>
        </div>
        <div className="header__socials">
          {
            data.map(item => <a key={item.id} href={item.link} target="_blank"
            rel="noopener noreferrer" aria-label={item.label}>{item.icon}</a>)
          }
        </div>
      </div>
    </header>
  )
}

export default Header;
